module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAUCAMAAAAePVXsAAAARVBMVEUAAABcev9eeP9eef9eeP9ceP9Uf/9def9ceP9adv9bdP9cdv9Ud/9eeP9ceP9eeP9deP9be/9eeP9dd/9bdv9ceP9feP/UWNeTAAAAF3RSTlMAGYBMzEAMJmYQCXEWsllGMiC/eDimjMOxs3oAAACiSURBVDjLrdNZDsMgDEXR2GbO3Gn/S+0fcFWpjZL67wmOZGEz/K0CozDG7mLgSUT0HjGl5qTA2Q6nDzi3NCd0luF0h3NbcxPdWuDuGe4m1ckEZ770TsfcOzdLdZLhzMNpKr1zz1CdZDjb4NTgnDYnAc4inK5wbjzqPF062OfCPl+1z+nru4wFbg5X53Bi7r/3TAa4eHKvL/2jzyqMmVGGa/UGfWEGn84XTVEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/productCenter/subnav3/tab3/bgImage5-content2.png
// module id = 3dBe
// module chunks = 0